<ng-container *ngIf="!isLoading() && merchandise(); else loading">
  <app-fullscreen-gallery
    *ngIf="isFullscreenOpen()"
    [images]="merchandise()!.images"
    [activeIndex]="fullscreenIndex()"
    (close)="closeFullscreen()"
  ></app-fullscreen-gallery>

  <app-inquiry-modal
    *ngIf="isInquiryOpen()"
    [productId]="merchandise()!.id"
    [inquiryType]="inquiryType()"
    brokerName="Seger Yachts"
    (close)="closeInquiry()"
  ></app-inquiry-modal>

  <section class="product-detail-page">
    <div class="detail-container">
      <button class="back-button" (click)="goBack()" aria-label="Back to Listings">
        ← Back to Listings
      </button>

      <div class="detail-grid" style="display: grid; grid-template-columns: 1fr; gap: 2rem">
        <!-- Desktop Override -->
        <style>
          @media (min-width: 1024px) {
            .detail-grid {
              grid-template-columns: 1.2fr 0.8fr !important;
              gap: 3rem !important;
            }
          }
        </style>

        <!-- Left Column: Gallery -->
        <div class="gallery-column">
          <app-image-gallery
            [images]="merchandise()!.images"
            (openFullscreen)="openFullscreen($event)"
          ></app-image-gallery>
        </div>

        <!-- Right Column: Info -->
        <div class="info-column">
          <header class="detail-header" style="margin-bottom: 1.5rem">
            <div
              class="detail-subtitle"
              style="
                color: #64748b;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.05em;
                margin-bottom: 0.5rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              "
            >
              <i class="fas fa-tshirt"></i> Merchandise
            </div>
            <div
              class="title-rating-row"
              style="
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 1rem;
              "
            >
              <h1
                class="detail-title"
                style="
                  font-size: 2.25rem;
                  font-weight: 800;
                  color: #1e293b;
                  margin: 0;
                  line-height: 1.2;
                "
              >
                {{ merchandise()!.title }}
              </h1>
              <div
                class="product-rating"
                *ngIf="merchandise()!.averageRating"
                style="
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                  background: #fef3c7;
                  color: #d97706;
                  padding: 0.4rem 0.8rem;
                  border-radius: 20px;
                  font-weight: 700;
                  flex-shrink: 0;
                "
              >
                <i class="fas fa-star star"></i>
                <span class="rating-val">{{ merchandise()!.averageRating | number: '1.1-1' }}</span>
              </div>
            </div>
            <div class="price-row" style="margin-top: 1rem">
              <span
                class="detail-price"
                style="font-size: 1.75rem; font-weight: 700; color: #10b981"
                >{{ merchandise()!.price | currency }}</span
              >
            </div>
          </header>

          <div class="badge-row" style="margin-bottom: 1.5rem">
            <div
              class="status-badge"
              style="
                display: inline-block;
                padding: 0.4rem 1rem;
                border-radius: 8px;
                font-weight: 700;
                text-transform: uppercase;
                font-size: 0.8rem;
                background: rgba(16, 185, 129, 0.1);
                color: #10b981;
              "
            >
              {{ merchandise()!.status }}
            </div>
            <div
              *ngIf="merchandise()!.stockCount > 0"
              style="
                margin-left: 0.75rem;
                display: inline-block;
                color: #64748b;
                font-size: 0.85rem;
                font-weight: 500;
              "
            >
              Only {{ merchandise()!.stockCount }} left in stock!
            </div>
          </div>

          <!-- Description Summary -->
          <div
            class="detail-description-summary"
            *ngIf="merchandise()!.description"
            style="margin-bottom: 2rem; border-bottom: 1px solid #f1f5f9; padding-bottom: 2rem"
          >
            <div
              [innerHTML]="merchandise()!.safeDescription"
              style="color: #4b5563; line-height: 1.8; font-size: 1.05rem; white-space: pre-wrap"
            ></div>
          </div>

          <!-- Actions Row -->
          <div
            class="cta-row-main"
            style="
              display: flex;
              flex-wrap: wrap;
              gap: 1rem;
              align-items: center;
              margin-bottom: 2rem;
            "
          >
            <button
              class="action-button primary interest-btn"
              (click)="addToCart(merchandise()!)"
              style="
                padding: 1.25rem 2rem;
                font-size: 1.1rem;
                font-weight: 700;
                border-radius: 12px;
                background: #0a192f;
                color: white;
                border: none;
                cursor: pointer;
                transition: all 0.2s;
                white-space: nowrap;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 0.75rem;
              "
            >
              <i class="fas fa-shopping-cart"></i> Add to Cart
            </button>

            <!-- Social Share Popup -->
            <div class="share-container" style="position: relative">
              <button
                class="action-button secondary share-trigger-btn"
                (click)="isSharePopupOpen.set(!isSharePopupOpen()); $event.stopPropagation()"
                style="
                  padding: 1.25rem 2rem;
                  font-size: 1.1rem;
                  font-weight: 700;
                  border-radius: 12px;
                  background: #f1f5f9;
                  color: #1e293b;
                  border: 1px solid #e2e8f0;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                "
              >
                Share
                <i
                  class="fas"
                  [class.fa-chevron-down]="!isSharePopupOpen()"
                  [class.fa-chevron-up]="isSharePopupOpen()"
                  style="font-size: 0.8rem"
                ></i>
              </button>

              <div
                class="share-dropdown"
                [class.share-open]="isSharePopupOpen()"
                style="
                  position: absolute;
                  top: calc(100% + 10px);
                  right: 0;
                  background: white;
                  border: 1px solid #e2e8f0;
                  border-radius: 12px;
                  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                  z-index: 1000;
                  min-width: 200px;
                  padding: 0.75rem;
                  display: flex;
                  flex-direction: column;
                  gap: 0.25rem;
                  visibility: hidden;
                  opacity: 0;
                  transform: translateY(-10px);
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                "
              >
                <button
                  (click)="shareTo('facebook', $event)"
                  class="share-item"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  "
                >
                  <i class="fab fa-facebook-f" style="color: #1877f2; width: 20px"></i> Facebook
                </button>
                <button
                  (click)="shareTo('instagram', $event)"
                  class="share-item"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  "
                >
                  <i class="fab fa-instagram" style="color: #e4405f; width: 20px"></i> Instagram
                </button>
                <button
                  (click)="shareTo('twitter', $event)"
                  class="share-item"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  "
                >
                  <i class="fa-brands fa-x-twitter">x</i> X
                </button>
                <button
                  (click)="shareTo('whatsapp', $event)"
                  class="share-item"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  "
                >
                  <i class="fab fa-whatsapp" style="color: #25d366; width: 20px"></i> WhatsApp
                </button>
                <div style="height: 1px; background: #f1f5f9; margin: 0.25rem 0"></div>
                <button
                  (click)="shareLink()"
                  class="share-item"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  "
                >
                  <i class="fas fa-link" style="color: #64748b; width: 20px"></i> Copy Link
                </button>
              </div>
              <style>
                .share-dropdown.share-open {
                  visibility: visible !important;
                  opacity: 1 !important;
                  transform: translateY(0) !important;
                }

                .share-item:hover {
                  background: #f8fafc !important;
                }
              </style>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs Navigation -->
      <div
        class="detail-tabs-nav"
        style="margin-top: 4rem; display: flex; border-bottom: 2px solid #f1f5f9; gap: 3rem"
      >
        <button
          class="tab-btn"
          [class.active]="activeTab() === 'details'"
          (click)="activeTab.set('details')"
          style="
            background: none;
            border: none;
            padding: 1rem 0.5rem;
            font-size: 1.1rem;
            font-weight: 700;
            cursor: pointer;
            position: relative;
          "
        >
          Product Details
          <div
            *ngIf="activeTab() === 'details'"
            style="
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 100%;
              height: 3px;
              background: #d4af37;
            "
          ></div>
        </button>
        <button
          class="tab-btn"
          [class.active]="activeTab() === 'reviews'"
          (click)="activeTab.set('reviews')"
          style="
            background: none;
            border: none;
            padding: 1rem 0.5rem;
            font-size: 1.1rem;
            font-weight: 700;
            cursor: pointer;
            position: relative;
          "
        >
          Reviews ({{ merchandise()!.reviewCount }})
          <div
            *ngIf="activeTab() === 'reviews'"
            style="
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 100%;
              height: 3px;
              background: #d4af37;
            "
          ></div>
        </button>
      </div>

      <div class="tab-content-wrapper" style="padding-top: 2rem">
        <div class="details-tab" *ngIf="activeTab() === 'details'">
          <div
            *ngIf="merchandise()!.safeDetails"
            class="details-container-inner"
            style="margin-bottom: 3rem; padding-bottom: 2rem; border-bottom: 1px solid #f1f5f9"
          >
            <h2 style="font-size: 1.5rem; font-weight: 800; color: #1e293b; margin-bottom: 1rem">
              Additional Information
            </h2>
            <div
              [innerHTML]="merchandise()!.safeDetails"
              style="color: #4b5563; font-size: 1.1rem; line-height: 1.6"
            ></div>
          </div>

          <!-- Grouped Features -->
          <section class="features-section" *ngIf="merchandise()!.features.length > 0">
            <h2
              style="
                font-size: 1.5rem;
                font-weight: 800;
                color: #1e293b;
                margin-bottom: 1.5rem;
                text-transform: uppercase;
                letter-spacing: 0.05em;
              "
            >
              Features & Specifications
            </h2>
            <div
              class="features-grid"
              style="
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                gap: 2rem;
              "
            >
              <div *ngFor="let group of merchandise()!.features" class="feature-group">
                <h3
                  style="
                    color: #d4af37;
                    font-size: 0.9rem;
                    font-weight: 800;
                    text-transform: uppercase;
                    margin-bottom: 1rem;
                    border-left: 3px solid #d4af37;
                    padding-left: 0.75rem;
                  "
                >
                  {{ group.type }}
                </h3>
                <ul
                  style="
                    list-style: none;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    gap: 0.75rem;
                  "
                >
                  <li
                    *ngFor="let f of group.features"
                    style="
                      display: flex;
                      align-items: flex-start;
                      gap: 0.75rem;
                      color: #475569;
                      font-size: 1rem;
                    "
                  >
                    <i class="fas fa-check" style="color: #10b981; margin-top: 4px"></i>
                    {{ f }}
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>

        <div class="reviews-tab" *ngIf="activeTab() === 'reviews'">
          <app-product-ratings
            [productId]="merchandise()!.id"
            [reviews]="merchandise()!.reviews"
          ></app-product-ratings>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<ng-template #loading>
  <div class="loading-state" style="padding: 100px; text-align: center">
    <p style="font-size: 1.25rem; font-weight: 600; color: #64748b">Loading...</p>
  </div>
</ng-template>
